<div class="dropdown-wrapper" [class.filters]="isFilterClass" [attr.aria-labelledby]="label ? id + '-label' : null">
  @if (label) {
    <label [id]="id + '-label'" [attr.for]="id">{{ label }}</label>
  }
  @if (searchable) {
    <div class="dropdown-container" (click)="onHeaderClick($event)">
      <div class="display-content">
        <input
          type="text"
          [(ngModel)]="searchTerm"
          [ngModelOptions]="{ standalone: true }"
          [attr.aria-label]="ariaLabel || null"
          [placeholder]="selectedLabel || placeholder"
          (focus)="isOpen = true"
          (input)="isOpen = true"
          [disabled]="disabled"
          (click)="$event.stopPropagation()"
          class="display-text"
          #searchInput
          />
      </div>
      <div class="arrow-icon" [class.open]="isOpen">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="12"
          height="8"
          viewBox="0 0 12 8"
          fill="none"
          stroke="currentColor"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
          >
          <path d="M1 1.5L6 6.5L11 1.5" />
        </svg>
      </div>
      @if (isOpen) {
        <div class="dropdown-menu">
          @for (option of displayedOptions; track $index) {
            <div
              class="dropdown-option"
              (click)="selectOption(option)"
              [class.selected]="isSelected(option)"
              >
              {{ option.label }}
            </div>
          }
          @if (displayedOptions.length === 0) {
            <div class="dropdown-option">No results</div>
          }
        </div>
      }
    </div>
  } @else {
    <div
      class="dropdown-container"
      [class.invalid]="isShowError && errorMessage"
      [class.disabled]="disabled"
      [class.open]="isOpen"
      [class.filters-applied]="showClear"
      [attr.aria-label]="ariaLabel || null"
      (click)="toggleDropdown()"
      >
      <div class="display-content">
        @if (iconPath) {
          <div class="icon-container">
            <!-- Changed class name -->
            <img [src]="iconPath" (error)="useFallbackIcon($event)" alt="Dropdown icon" class="dropdown-icon" />
            <!-- Use img tag -->
          </div>
        }
        <div class="display-text">
          @if (type === 'checkbox') {
            {{ getSelectedLabels().join('/') || placeholder }}
          } @else {
            {{ selectedLabel || placeholder }}
          }
        </div>
      </div>
      @if (loading) {
        <mat-spinner [diameter]="16" class="dropdown-spinner" />
      }
      @if (showClear) {
        <button type="button" class="clear-filter" title="Clear filters" (click)="clear($event)">
          <img src="shared-assets/icons/close.png" alt="Clear filters" class="clear-icon" />
        </button>
      }
      @if (!loading && !showClear) {
        <div class="arrow-icon" [class.open]="isOpen">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="12"
            height="8"
            viewBox="0 0 12 8"
            fill="none"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
            >
            <path d="M1 1.5L6 6.5L11 1.5" />
          </svg>
        </div>
      }
    </div>
  }

  @if (isOpen) {
    <div [class.disableScroll]="disableScroll" class="dropdown-menu" #dropdownMenu>
      @if (isSearch) {
        <div class="dropdown-search">
          <app-pill-search
            [searchText]="searchText"
            [placeholder]="searchPlaceholder"
            (searchChange)="onSearchChange($event)"
          [customStyles]="{
            'border-radius': '0px',
            width: '100%',
            'max-width': 'none',
            height: '38px',
          }"
          ></app-pill-search>
        </div>
      }
      @if (filteredOptions.length > 0) {
        @for (option of filteredOptions; track $index) {
          <div
            class="dropdown-option custom-checkbox"
            (click)="onOptionClicked(option, $event)"
            [class.selected]="isSelected(option)"
            [class.disabled]="option.disabled"
            >
            @if (type === 'checkbox') {
              <input type="checkbox" [checked]="isSelected(option)" readonly />
              <span class="checkmark"></span>
              <span>{{ option.label }}</span>
            } @else {
              {{ option.label }}
            }
          </div>
        }
      }
      @if (filteredOptions.length === 0 && isSearch) {
        <div class="no-options">No Results Found</div>
        @if (allowAdd && searchText.trim()) {
          <div class="add-item-container">
            <button type="button" class="add-item-btn" (click)="onAddItem()">
              <mat-icon class="add-icon">add</mat-icon>
              {{ addButtonLabel }}
            </button>
          </div>
        }
      }
    </div>
  }
  @if (isShowError && errorMessage) {
    <div class="error-message">
      <mat-icon class="error-icon">error_outline</mat-icon>
      {{ errorMessage }}
    </div>
  }
</div>
